import { Component } from "react";
import { gql } from "@apollo/client";
import { graphql } from "@apollo/client/react/hoc";
import { connect } from "react-redux";
import { Modal, Button, List, Grid, Form, Radio } from "semantic-ui-react";
import { Toasts } from "common/components/Toasts";
import { AVAILABILITY_BUFFER_TYPES } from "common/helpers/calendar";
import { availabilityBufferModalToggle } from "../../../Managers/Hiring/actions/uiCandidate";
import CalendarMutation from "../../../Managers/Hiring/mutations/UpdateCalendarMutation";

const QueryRaw = gql`
  query Calendar {
    calendar {
      id
      time_zone_name
      availability_buffer
      availability_buffer_time
    }
  }
`;

const Query = graphql(QueryRaw, {
  options: (ownProps) => {
    return {
      fetchPolicy: "network-only",
    };
  },
});

class AvailabilityBufferModal extends Component {
  state = {
    value: undefined,
  };

  static defaultProps = {
    onSubmit: () => {},
  };

  onClose = () => {
    this.props.dispatch(availabilityBufferModalToggle(false));
  };

  setAvailabilityType = (value) => this.setState({ value });

  handleChange = (e, { value }) => this.setState({ value });

  saveAvailabilityBuffer = () => this.submitCalendar();

  get currentAvailabilityType() {
    return (
      (this.props.data.calendar &&
        this.props.data.calendar.availability_buffer) ||
      "next_workday"
    );
  }

  submitCalendar = () => {
    this.setState({ submitting: true }, () => {
      this.props
        .mutate({
          variables: {
            availability_buffer: this.state.value,
          },
        })
        .then(({ data }) => {
          console.log("Submitted");
          this.setState({
            calendar: {
              ...this.props.data.calendar,
              availability_buffer: data.updateCalendar.availability_buffer,
              availability_buffer_time:
                data.updateCalendar.availability_buffer_time,
            },
          });
          Toasts.success("Your preference has been updated");
          this.props.onSubmit(data);
          this.onClose();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.setState({ submitting: false });
        });
    });
  };

  render() {
    return (
      <Modal
        open={this.props.availabilityBufferModalOpen}
        size="tiny"
        onClose={this.onClose}
      >
        <Modal.Header>Bookable interview buffer time</Modal.Header>
        <Modal.Content style={{ fontSize: "15px", fontWeight: "normal" }}>
          <p>
            By default, candidates can schedule interviews with you from the
            next business day onward to ensure you have adequate time to
            prepare.
          </p>
          <p style={{ marginBottom: "20px" }}>
            <strong>
              If you want candidates to schedule interviews sooner, change your
              buffer time setting below
            </strong>
            . Example: if you choose “2 hour buffer”, a candidate can schedule a
            4 pm interview with you as late as 2 pm.
          </p>
          <List celled relaxed verticalAlign="middle">
            {AVAILABILITY_BUFFER_TYPES.map((buffer) => (
              <List.Item
                key={buffer.value}
                as="a"
                onClick={() => this.setAvailabilityType(buffer.value)}
              >
                <Grid verticalAlign="middle">
                  <Grid.Column width={1}>
                    <Form.Field>
                      <Radio
                        name="appointmentBuffer"
                        value={buffer.value}
                        checked={
                          (this.state.value || this.currentAvailabilityType) ===
                          buffer.value
                        }
                        onChange={this.handleChange}
                      />
                    </Form.Field>
                  </Grid.Column>
                  <Grid.Column width={15}>
                    <List.Content floated="left">
                      <List.Header
                        style={{ fontWeight: "500", fontSize: "18px" }}
                      >
                        {buffer.title}
                      </List.Header>
                      <List.Description
                        style={{ fontSize: "15px", fontWeight: "normal" }}
                      >
                        {buffer.info}
                      </List.Description>
                    </List.Content>
                  </Grid.Column>
                </Grid>
              </List.Item>
            ))}
          </List>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.onClose} primary basic>
            Cancel
          </Button>
          <Button
            loading={this.state.submitting}
            onClick={this.saveAvailabilityBuffer}
            primary
            disabled={
              this.state.value === undefined ||
              this.currentAvailabilityType === this.state.value
            }
          >
            Update buffer preference
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
const mapStateToProps = (state) => ({
  availabilityBufferModalOpen: state.uiCandidate?.availabilityBufferModalOpen,
});
export default CalendarMutation(
  Query(connect(mapStateToProps)(AvailabilityBufferModal))
);
